import { type InsuranceCorporateIdentity } from "../types";

export function AllianzLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M281.486 356.418V156.262C281.486 140.12 274.69 134.853 259.398 134.853H213.521V156.942H218.619C227.115 156.942 230.512 160.17 230.512 170.025V356.418H281.486ZM308.671 356.418H357.946V205.367C357.946 190.075 351.151 183.958 335.859 183.958H308.671V356.418ZM203.327 356.418V183.958H176.141C160.849 183.958 154.052 190.075 154.052 205.367V356.418H203.327ZM415.716 255.831C415.716 349.452 347.751 417.756 255.999 417.756C164.247 417.756 96.2816 349.452 96.2816 255.831C96.2816 162.21 164.247 93.9046 255.999 93.9046C347.751 93.9046 415.716 162.21 415.716 255.831ZM448 255.831C448 146.238 366.442 64 255.999 64C147.255 64 64 146.238 64 255.831C64 365.764 147.255 448.001 255.999 448.001C366.442 448.001 448 365.764 448 255.831Z"
        fill="white"
      />
    </svg>
  );
}

export const Allianz: InsuranceCorporateIdentity = {
  id: "allianz",
  name: "Allianz",
  logo: AllianzLogo,
  backgroundColor: "#003781",
  textColor: "#FFFFFF",
  wildcard: "allianz",
  type: "private",
};
